import React from "react";
import { Box } from "@mui/material";
import HeroSection from "../components/HeroSection";
import StatsSection from "../components/StatsSection";
import CentraleAchatTeaser from "../components/CentraleAchatTeaser";
import FarmersMap from "../components/Map/FarmersMap";
import DiagnosticSection from "../components/DiagnosticSection";
import FarmerRegistration from "../components/FarmerRegistration";
import CallToAction from "../components/CallToAction";

const HomePage = () => (
  <>
    <HeroSection />
    <StatsSection />
    <CentraleAchatTeaser />
    <FarmersMap />
    <Box sx={{ backgroundColor: "rgb(1, 69, 39)" }}>
      <DiagnosticSection />
    </Box>
    <FarmerRegistration/>
    <CallToAction/>
  </>
);

export default HomePage;
